import NylasSyncOptions from "@app/types/nylas/NylasSyncOptions";

import NylasFormSyncDirection from "../enum/NylasFormSyncDirection";

export const convertNylesOptionsToSyncDirection = (
  options?: NylasSyncOptions
): NylasFormSyncDirection => {
  if (!options?.incoming) {
    return NylasFormSyncDirection.OUTGOING;
  }
  if (!options?.outgoing) {
    return NylasFormSyncDirection.INCOMING;
  }
  return NylasFormSyncDirection.TWO_WAY;
};

export const convertSyncDirectionToNylesOptions = (
  direction: NylasFormSyncDirection
): NylasSyncOptions => ({
  incoming: [NylasFormSyncDirection.INCOMING, NylasFormSyncDirection.TWO_WAY].includes(direction),
  outgoing: [NylasFormSyncDirection.OUTGOING, NylasFormSyncDirection.TWO_WAY].includes(direction),
});
